import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "./redux/packagesSalesSaga";

import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import SecondaryCategory from "./smartComponents/secondaryCategory";
import TableOrLineChart from "./smartComponents/tableOrLineChart";
import CustomDateRanges from "./smartComponents/customDateRanges";
import OnlyChallengers from "./smartComponents/onlyChallengers";
import ExcludeMembership from "./smartComponents/excludeMembership";
import ExcludeZeroSessions from "./smartComponents/excludeZeroSessions";
import PrimaryCategory from "./smartComponents/primaryCategory";
import PricingOption from "./smartComponents/pricingOption";
import DatePicker from "./smartComponents/datePicker";
import PeriodType from "./smartComponents/periodType";
import GroupBy from "./smartComponents/groupBy";
import KBLearnMore from "../../../components/learnMore/KBLearnMore";
import { ILEARN_URLS } from "../../../constants/ilearnUrls";
import { isEmpty } from "lodash";
import "./packagesSalesModule.css";

const PackagesSalesModule = (props) => {
  const dispatch = useDispatch();
  const useSecondaryCategories = useSelector(
    (state) => state.packagesSales.currentUser.useSecondaryCategories
  );
  const initialRequest = useSelector((state) => state.packagesSales.initialRequest);
  const filtersDirty = useSelector((state) => state.packagesSales.filtersDirty);
  const isLoading = useSelector((state) => state.packagesSales.isLoading);
  const onlyChallengers = useSelector(
    (state) => state.packagesSales.filters.toggles.onlyChallengers
  );
  const pricingOptions = useSelector(
    (state) => state.packagesSales.selectedFilters.pricing_options
  );
  const { status: chartStatus, error: chartError } = useSelector(
    (state) => state.packagesSales.chartInfo
  );

  useEffect(() => {
    if (!initialRequest) {
      dispatch(actionCreators.fetchCurrentUser({ ...props }));
    }
  }, []);

  const resetData = () => {
    dispatch(actionCreators.resetFilters());
  };

  const handleOnClick = () => {
    dispatch(actionCreators.updateData("UPDATE"));
  };

  const renderUpdateBtn = () => {
    if (filtersDirty || chartStatus == "idle") {
      return (
        <button
          className="submit override-submit"
          onClick={handleOnClick}
          disabled={chartStatus == "idle" && pricingOptions.length > 1000}
          style={{ right: filtersDirty ? "105px" : "45px" }}
        >
          {chartStatus == "idle" ? "Load" : "Update"}
        </button>
      );
    }

    return null;
  };

  const renderResetBtn = () => {
    if (filtersDirty && !isLoading) {
      return (
        <button className="submit reset override-submit" onClick={resetData}>
          Reset
        </button>
      );
    }

    return null;
  };

  return (
    <div id="packages-sales-root">
      <SectionToggle
        autoHeight
        height={690}
        title={`${props.chartName} Sales`}
        customClass="packages-sales-section"
        isLoading={isLoading}
        learnMore={
          <KBLearnMore
            title="Packages Sales"
            description="This report shows all package purchases across selected categories and package types during the chosen date range. These insights help you identify high-performing packages, monitor sales trends, and evaluate customer purchasing behavior."
            kbUrl={ILEARN_URLS.packages.packagesSales}
          />
        }
        content={
          <div>
            <div id="override-edit-selection-bar" className="edit-selections-bar">
              <div className="top-filter">
                <div className="dates-container">
                  <div className="select-box-no-width date-range-select-box">
                    <p>Date Range</p>
                    <CustomDateRanges />
                  </div>

                  <div className="date-select-box select-box-no-width multi">
                    <>
                      <p>Date</p>
                      <DatePicker />
                    </>
                  </div>
                </div>
                <div>
                  <div className={`top-left-filter ${useSecondaryCategories ? "" : "extend"}`}>
                    {useSecondaryCategories && (
                      <div className="select-box-no-width">
                        <p>Primary Category</p>
                        <PrimaryCategory />
                      </div>
                    )}
                    <div className="select-box-no-width">
                      <p>{`${useSecondaryCategories ? "Secondary" : ""} Category`}</p>
                      <SecondaryCategory />
                    </div>
                    <div className="select-box-no-width">
                      <p>Sales Package</p>
                      <PricingOption />
                    </div>

                    <div className="select-box-no-width">
                      <p>Group By</p>
                      <GroupBy />
                    </div>
                  </div>
                  <div className="top-right-filter">
                    <div className="select-box-no-width">
                      <p>Period Type</p>
                      <PeriodType />
                    </div>

                    <div className="button-control-group">
                      {renderUpdateBtn()}
                      {renderResetBtn()}
                    </div>
                    {chartStatus == "loaded" && chartError && (
                      <div className="info-alert">{chartError}</div>
                    )}
                  </div>
                </div>
              </div>

              <div className="bottom-filter">
                {!isEmpty(onlyChallengers) && (
                  <div className="select-box-no-width">
                    <p>{onlyChallengers.label}</p>
                    <OnlyChallengers />
                  </div>
                )}
                <ExcludeMembership />
                <ExcludeZeroSessions />
              </div>
            </div>
            <div className="chart-root">
              <TableOrLineChart />
              {chartStatus === "idle" ? (
                <div
                  className="error error--big"
                  style={{ textAlign: "center", lineHeight: "48px" }}
                >
                  {chartError}
                </div>
              ) : null}
            </div>
          </div>
        }
      />
    </div>
  );
};
export default React.memo(PackagesSalesModule);
